import { render, staticRenderFns } from "./UploadImageBanner.vue?vue&type=template&id=45b6e1bf&scoped=true&"
import script from "./UploadImageBanner.vue?vue&type=script&lang=js&"
export * from "./UploadImageBanner.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageBanner.vue?vue&type=style&index=0&id=45b6e1bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b6e1bf",
  null
  
)

export default component.exports